import CheckMarkIcon from '../../assets/data-upload-success.svg';
import WarningIcon from '../../assets/data-upload-warning-amber.svg';

import './MatchingStatusInfo.css';

interface MatchingStatusInfoProps {
  subjectType: string;
  value: number;
  description: JSX.Element;
  className?: string;
  label?: string;
}
function MatchingStatusInfo({ subjectType, value, description, className = '', label }: MatchingStatusInfoProps) {
  const isError = value < 100;

  return (
    <div className={`matching-status-info ${className}`}>
      {label ? <p className="no-margin status-info-label">{label}</p> : null}
      <img className="icon-size" src={isError ? WarningIcon : CheckMarkIcon} alt="matching status" />
      <p className={`no-margin ${isError ? 'matching-error' : ''} info-text`}>
        <span className="bolded">{isError ? 100 - value : value}% </span>
        of {subjectType}&nbsp;
        {isError ? <span className="bolded">NOT </span> : null}
        {description}
      </p>
    </div>
  );
}

export default MatchingStatusInfo;
